import fetch from 'isomorphic-fetch'
import Cookie from 'js-cookie'
import { checkHttpStatus, handleNetworkError, parseJSON, getCookie, addAuthorizeHeader } from '../../utils'

import { createTypes, actionCreator } from 'redux-action-creator';
import { fetchUser } from '../user/actions';
import { setStep } from '../step-renderer/actions';

export const subscriptionTypes = createTypes(['REQUEST', 'RECEIVE', 'SUCCESS', 'ERROR', 'REQUEST_TEMP_TOKEN', 'RECEIVE_TEMP_TOKEN', 'SUCCESS_TEMP_TOKEN', 'ERROR_TEMP_TOKEN', 'RECEIVE_TOKEN_STATUS', 'REQUEST_TOKEN_STATUS', 'ERROR_TOKEN_STATUS',
    // Subscription Contracts V2 / embedded checkout
    'REQUEST_CHECKOUT_SESSION', 'RECEIVE_CHECKOUT_SESSION', 'ERROR_CHECKOUT_SESSION', 'CHECKOUT_COMPLETED',
    'REQUEST_CONTRACT', 'RECEIVE_CONTRACT', 'ERROR_CONTRACT',], 'SUBSCRIPTION');


export const requestSubscription = (response) => {
    return {
        type: subscriptionTypes.REQUEST,
        data: response
    };
};


export const receiveSubscription = (response) => {
    return {
        type: subscriptionTypes.RECEIVE,
        data: response,
    };
};

export const receiveSubscriptionError = (response) => {
    return {
        type: subscriptionTypes.ERROR,
        data: response
    };
};


export const requestTemporaryToken = (response) => {
    return {
        type: subscriptionTypes.REQUEST_TEMP_TOKEN,
        data: response
    };
};


export const receiveTemporaryToken = (response) => {
    return {
        type: subscriptionTypes.RECEIVE_TEMP_TOKEN,
        data: response,
    };
};

export const receiveTemporaryTokenError = (response) => {
    return {
        type: subscriptionTypes.ERROR_TEMP_TOKEN,
        data: response
    };
};

export const requestTokenStatus = () => {
    return {
        type: subscriptionTypes.REQUEST_TOKEN_STATUS,
    };
};


export const receiveTokenStatus = (response) => {
    return {
        type: subscriptionTypes.RECEIVE_TOKEN_STATUS,
        data: response,
    };
};

export const receiveTokenStatusError = (response) => {
    return {
        type: subscriptionTypes.ERROR_TOKEN_STATUS,
        data: response
    };
};


export const fetchSubscription = (subscription_id) => {
  return dispatch => {

      dispatch(requestSubscription())
      let success = true
      return fetch('/payments/subscriptions/' + subscription_id, {
          method: "GET",
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=UTF-8',
              'X-CSRFToken': getCookie("guitarpartycsrftoken"),
              credentials: 'include'
          }
          // body: JSON.stringify(
          //     Object.assign({subscription: subscription_id})
          // )
      })
      .then(response => {
          if(response.status !== 200) {
              success = false
              if (response.status >= 500) {
                  dispatch(receiveSubscriptionError({error: gettext("A server error occurred. Please try again later.")}))
              }
          }
          return response
      })
      .then(parseJSON)
      .then(response => {
          if (success) {
              dispatch(receiveSubscription(response));
              dispatch(fetchUser())
          } else {
              dispatch(receiveSubscriptionError(response))
          }
      })
      .catch(handleNetworkError);
  };
}


export const subscribe = (plan_id, token, cardObj) => {
    return dispatch => {

        dispatch(requestSubscription())
        let success = true

        let body = {
            plan: plan_id,
            token: token,
        }
        Object.assign(body, cardObj)
        delete body.cardNumber
        delete body.cvc
        delete body.expiryDate

        return fetch('/payments/subscribe/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'X-CSRFToken': getCookie("guitarpartycsrftoken"),
                credentials: 'include'
            },
            body: JSON.stringify(body)
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
                if (response.status >= 500) {
                    dispatch(receiveSubscriptionError({error: gettext("A server error occurred. Please try again later.")}))
                }
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveSubscription(response));
                dispatch(fetchUser())
                dispatch(setStep(1))
            } else {
                dispatch(receiveSubscriptionError(response))
            }
        })
        .catch(handleNetworkError);
    };
}
export const createTemporaryToken = (cardObj, plan_id) => {
    return dispatch => {

        let expiry = cardObj.expiryDate.split("/")

        dispatch(requestTemporaryToken())
        let success = true
        return fetch(`${window.ASKELL_ENDPOINT}/temporarypaymentmethod/`, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Api-Key ${window.ASKELL_PUBLIC_KEY}`,
            },
            body: JSON.stringify({
                'card_number': cardObj.cardNumber.replaceAll(" ", ""),
                'expiration_year': expiry[1].trim(),
                'expiration_month': expiry[0].trim(),
                'cvv_number': cardObj['cvc'],
                'plan': plan_id
            })
        })
        .then(response => {
            if(response.status !== 201) {
                success = false
                if (response.status >= 500) {
                    dispatch(receiveTemporaryTokenError({error: gettext("A server error occurred. Please try again later.")}))
                }
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveTemporaryToken(response));
            } else {
                dispatch(receiveTemporaryTokenError(response))
            }
        })
        .catch(handleNetworkError);
    };
}

export const updateCreditcard = (user_id, token, cardObj) => {
    return dispatch => {

        let body = {
            token: token,
        }

        dispatch(requestSubscription())
        let success = true
        return fetch('/payments/updatecard/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'X-CSRFToken': getCookie("guitarpartycsrftoken"),
                credentials: 'include'
            },
            body: JSON.stringify(
                body
            )
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
                if (response.status >= 500) {
                    dispatch(receiveSubscriptionError({error: gettext("A server error occurred. Please try again later.")}))
                }
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveSubscription(response));
                dispatch(fetchUser())
                dispatch(setStep(1))
            } else {
                dispatch(receiveSubscriptionError(response))
            }
        })
        .catch(handleNetworkError);
    };
}


export const cancel = () => {
    return dispatch => {

        dispatch(requestSubscription())
        let success = true
        return fetch('/payments/cancel/', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'X-CSRFToken': getCookie("guitarpartycsrftoken"),
                credentials: 'include'
            }
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
                if (response.status >= 500) {
                    dispatch(receiveSubscriptionError({error: gettext("A server error occurred. Please try again later.")}))
                }
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveSubscription(response));
                dispatch(fetchUser())
            } else {
                dispatch(receiveSubscriptionError(response))
            }
        })
        .catch(handleNetworkError);
    };
}



export const fetchTokenStatus = (token) => {
    return dispatch => {
  
        dispatch(requestTokenStatus())
        let success = true
        return fetch(`${window.ASKELL_ENDPOINT}/temporarypaymentmethod/${token}/`, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': `Api-Key ${window.ASKELL_PUBLIC_KEY}`,
        }
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
                if (response.status >= 500) {
                    dispatch(receiveTokenStatusError({error: gettext("A server error occurred. Please try again later.")}))
                }
            }
            return response
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveTokenStatus(response));
            } else {
                dispatch(receiveTokenStatusError(response))
            }
        })
        .catch(handleNetworkError);
    };
  }


// ---------------------------------------------------------------------------
// Subscription Contracts V2 / embedded checkout
// ---------------------------------------------------------------------------

export const requestCheckoutSession = () => ({ type: subscriptionTypes.REQUEST_CHECKOUT_SESSION })
export const receiveCheckoutSession = (response) => ({ type: subscriptionTypes.RECEIVE_CHECKOUT_SESSION, data: response })
export const receiveCheckoutSessionError = (response) => ({ type: subscriptionTypes.ERROR_CHECKOUT_SESSION, data: response })
export const checkoutCompleted = (result) => ({ type: subscriptionTypes.CHECKOUT_COMPLETED, data: result })
export const requestContract = () => ({ type: subscriptionTypes.REQUEST_CONTRACT })
export const receiveContract = (response) => ({ type: subscriptionTypes.RECEIVE_CONTRACT, data: response })
export const receiveContractError = (response) => ({ type: subscriptionTypes.ERROR_CONTRACT, data: response })


const jsonRequest = (url, method, body) => {
    let options = {
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
            'X-CSRFToken': getCookie("guitarpartycsrftoken"),
        },
        credentials: 'include',
    }
    if (body !== undefined) {
        options.body = JSON.stringify(body)
    }
    return fetch(url, options).then(response => {
        return response.json()
            .catch(() => ({}))
            .then(data => ({ ok: response.ok, status: response.status, data: data }))
    })
}

const errorMessage = (result, fallback) => {
    if (result.data && result.data.message) {
        return result.data.message
    }
    if (result.status >= 500) {
        return gettext("A server error occurred. Please try again later.")
    }
    return fallback
}

// Ask our backend for a short-lived Áskell checkout session on the sales
// channel for `currency`. Only the session token reaches the browser.
export const createCheckoutSession = (currency, colorScheme, source = 'web') => {
    return dispatch => {
        dispatch(requestCheckoutSession())
        return jsonRequest('/payments/v2/checkout-session/', 'POST', {
            currency: currency,
            color_scheme: colorScheme,
            source: source,
        })
        .then(result => {
            if (result.ok && result.data.status === 'success') {
                dispatch(receiveCheckoutSession(result.data))
                return result.data
            }
            let message = errorMessage(result, gettext("Could not start checkout. Please try again."))
            dispatch(receiveCheckoutSessionError({ message: message }))
            let error = new Error(message)
            // 409 already_subscribed: one subscription per user
            error.status = result.status
            error.code = result.data && result.data.code
            throw error
        })
    }
}

// Called after the widget reports success: the backend verifies the
// contract with Áskell before the user is treated as a subscriber.
export const syncContract = (contractId) => {
    return dispatch => {
        dispatch(requestContract())
        let body = {}
        if (contractId) {
            body.contract_id = contractId
        }
        return jsonRequest('/payments/v2/contract/', 'POST', body)
        .then(result => {
            if (result.ok && result.data.status === 'success') {
                dispatch(receiveContract(result.data))
                return result.data
            }
            let message = errorMessage(result, gettext("Could not verify your subscription. Please refresh the page."))
            dispatch(receiveContractError({ message: message }))
            throw new Error(message)
        })
    }
}

export const fetchContract = () => {
    return dispatch => {
        dispatch(requestContract())
        return jsonRequest('/payments/v2/contract/', 'GET')
        .then(result => {
            if (result.ok && result.data.status === 'success') {
                dispatch(receiveContract(result.data))
                return result.data
            }
            dispatch(receiveContractError({ message: errorMessage(result, gettext("Could not load your subscription.")) }))
            return null
        })
        .catch(handleNetworkError)
    }
}

const contractAction = (url, body, fallbackMessage) => {
    return dispatch => {
        dispatch(requestContract())
        return jsonRequest(url, 'POST', body)
        .then(result => {
            if (result.ok && result.data.status === 'success') {
                dispatch(receiveContract(result.data))
                dispatch(fetchUser())
                return result.data
            }
            dispatch(receiveContractError({ message: errorMessage(result, fallbackMessage) }))
            return null
        })
        .catch(handleNetworkError)
    }
}

export const cancelContract = () => {
    return contractAction('/payments/v2/contract/cancel/', {}, gettext("Could not cancel the subscription. Please try again."))
}

// What switching to the other billing interval costs today (credit for
// the unused rest of the current period, charge for the new period).
// Resolves to the preview or null; not stored in redux.
export const previewContractSwitch = (interval) => {
    return jsonRequest('/payments/v2/contract/switch/?interval=' + encodeURIComponent(interval), 'GET')
    .then(result => {
        if (result.ok && result.data.status === 'success') {
            return result.data
        }
        throw new Error(errorMessage(result, gettext("Could not calculate the change. Please try again.")))
    })
}

// Switch between monthly and yearly billing, prorated and effective today:
// the unused rest of the current period is credited, the new period is
// charged now and the renewal date moves one period ahead.
export const switchContractInterval = (interval) => {
    return contractAction('/payments/v2/contract/switch/', { interval: interval }, gettext("Could not change the billing interval. Please try again."))
}

// Undo "stop renewal" while the contract still grants access.
export const restartContract = () => {
    return contractAction('/payments/v2/contract/restart/', {}, gettext("Could not resume the subscription. Please try again."))
}
